export default __webpack_public_path__ + "static/media/google-btn.21725acd.svg";